import React from 'react';
import { Avatar, Button, Typography } from 'antd';
import styles from './EditModal.module.css';

interface EditModalImageProps {
  imageId: number | null | undefined;
  imageMap: Map<number, string>;
  name?: string;
  onSetImage: () => void;
}

const { Title } = Typography;

const EditModalImage: React.FC<EditModalImageProps> = ({ imageId, imageMap, name, onSetImage }) => {
  const imageUrl = imageId ? imageMap.get(imageId) : undefined;

  return (
    <div className={styles.imageContainer}>
      {imageUrl && name && (
        <Title level={5} style={{ textAlign: 'center', marginBottom: '0.5rem', wordBreak: 'break-word' }}>{name}</Title>
      )}
      <Avatar
        shape="square"
        size={150}
        src={imageUrl}
        className={imageUrl ? styles.avatar : styles.avatarPlaceholder}
      >
        {!imageUrl && (
          <Button type="dashed" onClick={onSetImage} className={styles.setImageButton}>
            Set Image
          </Button>
        )}
      </Avatar>
    </div>
  );
};

export default EditModalImage;